// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3xJZ_","questions":"styles_questions__zLgNI","footer":"styles_footer__QRXoY"};